export const MOST_DAMAGE = 1.6
export const LESS_DAMAGE = 0.625
export const LEAST_DAMAGE = 0.391